import { STATIC_DEV_URL, STATIC_PROD_URL, STATIC_TEST_URL } from '@anm/constants/urls';

var globalCdnUrl = function () {
  switch (process.env['STATIC_ENV']) {
    case 'dev':
      return STATIC_DEV_URL;

    case 'test':
      return STATIC_TEST_URL;

    case 'prod':
      return STATIC_PROD_URL;

    default:
      throw new Error('Missed environment: STATIC_ENV');
  }
}();

var getFromCdn = function getFromCdn(src, cdnUrl) {
  return cdnUrl ? "".concat(cdnUrl, "static/").concat(src) : "".concat(globalCdnUrl).concat(src);
};

export default getFromCdn;